/* =====================================================================
   TOURNIKA — carrousels, galerie, sélection de taille, guide des tailles,
   ajout au panier et tiroir panier. Aucune dépendance.
   ===================================================================== */
(function () {
  'use strict';
  if (window.Tournika) return;
  var T = (window.Tournika = {});

  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }

  /* -------------------------------------------------------------- verrou de défilement */
  var locks = 0;
  function lock() { locks++; document.documentElement.classList.add('tk-lock'); }
  function unlock() { locks = Math.max(0, locks - 1); if (!locks) document.documentElement.classList.remove('tk-lock'); }

  /* -------------------------------------------------------------- carrousels */
  function initCarousel(el) {
    if (el.getAttribute('data-tk-ready')) return;
    el.setAttribute('data-tk-ready', '1');
    var track = el.querySelector('[data-tk-track]');
    if (!track) return;
    var slides = qsa('[data-tk-slide]', track);
    var prev = el.querySelector('[data-tk-prev]');
    var next = el.querySelector('[data-tk-next]');
    var dotsWrap = el.querySelector('[data-tk-dots]');
    var dots = [];
    var current = -1;

    function pad() { return parseFloat(getComputedStyle(track).paddingLeft) || 0; }
    function maxScroll() { return track.scrollWidth - track.clientWidth; }
    function positions() {
      // index de la dernière slide encore « alignable » à gauche
      var max = maxScroll();
      var count = 0;
      for (var i = 0; i < slides.length; i++) {
        count = i + 1;
        if (slides[i].offsetLeft - pad() >= max - 2) break;
      }
      return Math.max(1, count);
    }
    function activeIndex() {
      var x = track.scrollLeft + pad();
      if (track.scrollLeft >= maxScroll() - 2) return positions() - 1;
      var best = 0, dist = Infinity;
      for (var i = 0; i < slides.length; i++) {
        var d = Math.abs(slides[i].offsetLeft - x);
        if (d < dist) { dist = d; best = i; }
      }
      return Math.min(best, positions() - 1);
    }
    function goTo(i, instant) {
      var s = slides[Math.max(0, Math.min(i, slides.length - 1))];
      if (!s) return;
      var left = Math.min(s.offsetLeft - pad(), maxScroll());
      if (instant) { track.style.scrollBehavior = 'auto'; track.scrollLeft = left; track.style.scrollBehavior = ''; }
      else track.scrollTo({ left: left, behavior: 'smooth' });
    }
    function buildDots() {
      if (!dotsWrap) return;
      var n = positions();
      dotsWrap.innerHTML = '';
      dots = [];
      if (n <= 1) { dotsWrap.hidden = true; return; }
      dotsWrap.hidden = false;
      for (var i = 0; i < n; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'tk-dot';
        b.setAttribute('aria-label', (i + 1) + ' / ' + n);
        (function (idx) { b.addEventListener('click', function () { goTo(idx); }); })(i);
        dotsWrap.appendChild(b);
        dots.push(b);
      }
      current = -1;
    }
    function update() {
      var i = activeIndex();
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= maxScroll() - 2;
      if (i === current) return;
      current = i;
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      el.dispatchEvent(new CustomEvent('tk:change', { detail: { index: i } }));
    }

    if (prev) prev.addEventListener('click', function () { goTo(activeIndex() - 1); });
    if (next) next.addEventListener('click', function () { goTo(activeIndex() + 1); });
    var raf = null;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = null; update(); });
    }, { passive: true });
    var rt = null;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { buildDots(); update(); }, 150);
    });

    el.tkGoTo = goTo;
    el.tkSlides = slides;
    buildDots();
    update();
  }

  /* -------------------------------------------------------------- galerie produit */
  function initGallery(g) {
    if (g.getAttribute('data-tk-gallery-ready')) return;
    g.setAttribute('data-tk-gallery-ready', '1');
    var car = g.querySelector('[data-tk-carousel]');
    var strip = g.querySelector('[data-tk-thumbs]');
    var thumbs = qsa('[data-tk-thumb]', g);
    var tPrev = g.querySelector('[data-tk-thumbs-prev]');
    var tNext = g.querySelector('[data-tk-thumbs-next]');
    var cur = 0;
    if (!car) return;
    initCarousel(car);
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { if (car.tkGoTo) car.tkGoTo(+t.getAttribute('data-tk-thumb')); });
    });
    function stepTo(i) {
      if (!car.tkGoTo || !car.tkSlides) return;
      car.tkGoTo(Math.max(0, Math.min(i, car.tkSlides.length - 1)));
    }
    if (tPrev) tPrev.addEventListener('click', function () { stepTo(cur - 1); });
    if (tNext) tNext.addEventListener('click', function () { stepTo(cur + 1); });
    car.addEventListener('tk:change', function (e) {
      cur = e.detail.index;
      thumbs.forEach(function (t, k) {
        var on = k === cur;
        t.classList.toggle('is-active', on);
        if (on && strip && strip.scrollTo) strip.scrollTo({ left: t.offsetLeft - (strip.clientWidth - t.clientWidth) / 2, behavior: 'smooth' });
      });
      if (tPrev) tPrev.disabled = cur <= 0;
      if (tNext && car.tkSlides) tNext.disabled = cur >= car.tkSlides.length - 1;
    });
    g.tkShowMedia = function (mediaId) {
      if (!mediaId || !car.tkSlides) return;
      for (var i = 0; i < car.tkSlides.length; i++) {
        if (car.tkSlides[i].getAttribute('data-media-id') === String(mediaId)) { car.tkGoTo(i); return; }
      }
    };
  }

  /* -------------------------------------------------------------- produit : variantes + ajout au panier */
  function initProduct(sec) {
    if (sec.getAttribute('data-tk-product-ready')) return;
    sec.setAttribute('data-tk-product-ready', '1');
    var data;
    try { data = JSON.parse(sec.querySelector('[data-tk-product-json]').textContent); } catch (e) { return; }
    var form = sec.querySelector('form.tk-form');
    var idInput = sec.querySelector('[data-tk-variant-id]');
    var btn = sec.querySelector('[data-tk-submit]');
    var label = sec.querySelector('[data-tk-submit-label]');
    var errEl = sec.querySelector('[data-tk-error]');
    var priceEl = sec.querySelector('[data-tk-price]');
    var compareEl = sec.querySelector('[data-tk-compare]');
    var gallery = sec.querySelector('[data-tk-gallery]');
    var sets = qsa('[data-tk-option]', sec);
    var offersRoot = sec.querySelector('[data-tk-offers]');
    var offerCards = offersRoot ? qsa('[data-tk-offer]', offersRoot) : [];

    function showError(msg) {
      if (!errEl) return;
      errEl.textContent = msg || sec.getAttribute('data-error');
      errEl.hidden = false;
    }
    function selected() {
      return sets.map(function (fs) { var c = fs.querySelector('input:checked'); return c ? c.value : null; });
    }
    function find(opts) {
      for (var i = 0; i < data.variants.length; i++) {
        var v = data.variants[i], ok = true;
        for (var k = 0; k < opts.length; k++) { if (v.options[k] !== opts[k]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }
    function setButton(v) {
      if (!btn) return;
      if (!v) { btn.disabled = true; label.textContent = sec.getAttribute('data-soldout'); return; }
      btn.disabled = !v.available;
      label.textContent = v.available ? sec.getAttribute('data-add') : sec.getAttribute('data-soldout');
    }

    /* ---- packs : une ligne (#1, #2…) par pièce, couleur + taille au choix */
    function selectedCard() {
      if (!offersRoot) return null;
      return offersRoot.querySelector('[data-tk-offer].is-selected') || offerCards[0] || null;
    }
    function rowOptions(row) { return qsa('[data-tk-unit-select]', row).map(function (s) { return s.value; }); }
    function paintSwatch(select) {
      var sw = select.parentNode && select.parentNode.querySelector('[data-tk-swatch]');
      if (!sw) return;
      var opt = select.options[select.selectedIndex];
      sw.style.setProperty('--tk-swatch', (opt && opt.getAttribute('data-swatch')) || '#e5e5e5');
    }
    function validateOffer(keepError) {
      var card = selectedCard();
      if (!card) return;
      var rows = qsa('[data-tk-unit]', card);
      var ok = true;
      rows.forEach(function (row) {
        var v = find(rowOptions(row));
        var bad = !v || !v.available;
        row.classList.toggle('is-invalid', bad);
        if (bad) ok = false;
      });
      if (!rows.length) ok = data.variants.length > 0 && data.variants[0].available;
      if (errEl && !keepError) errEl.hidden = true;
      setButton(ok ? { available: true } : null);
    }
    function copyChoices(from, to) {
      if (!from || !to || from === to) return;
      var src = qsa('[data-tk-unit]', from);
      if (!src.length) return;
      qsa('[data-tk-unit]', to).forEach(function (row, i) {
        var ref = rowOptions(src[i] || src[0]);
        qsa('[data-tk-unit-select]', row).forEach(function (s, k) {
          if (ref[k] == null) return;
          s.value = ref[k];
          paintSwatch(s);
        });
      });
    }
    if (offersRoot) {
      offersRoot.addEventListener('change', function (e) {
        var t = e.target;
        if (t.classList.contains('tk-offer__radio')) {
          var before = selectedCard();
          var after = t.closest('[data-tk-offer]');
          copyChoices(before, after);
          offerCards.forEach(function (c) { c.classList.toggle('is-selected', c === after); });
          validateOffer();
          return;
        }
        if (t.hasAttribute('data-tk-unit-select')) {
          paintSwatch(t);
          validateOffer();
          if (t.hasAttribute('data-tk-color')) {
            var v = find(rowOptions(t.closest('[data-tk-unit]')));
            if (v && v.media && gallery && gallery.tkShowMedia) gallery.tkShowMedia(v.media);
          }
        }
      });
      qsa('[data-tk-unit-select]', offersRoot).forEach(paintSwatch);
      validateOffer();
    }

    /* ---- choix simple (pastilles), sans packs */
    function markAvailability(opts) {
      sets.forEach(function (fs, idx) {
        qsa('input', fs).forEach(function (inp) {
          var test = opts.slice(); test[idx] = inp.value;
          var v = find(test);
          var lab = fs.querySelector('label[for="' + inp.id + '"]');
          if (lab) lab.classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    }
    function update(fromUser, keepError) {
      var opts = selected();
      sets.forEach(function (fs, i) { var o = fs.querySelector('[data-tk-option-value]'); if (o) o.textContent = opts[i] || ''; });
      markAvailability(opts);
      var v = find(opts);
      setButton(v);
      if (errEl && !keepError) errEl.hidden = true;
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.innerHTML = v.price;
      if (compareEl) {
        if (v.compare) { compareEl.innerHTML = v.compare; compareEl.hidden = false; } else compareEl.hidden = true;
      }
      if (fromUser) {
        if (v.media && gallery && gallery.tkShowMedia) gallery.tkShowMedia(v.media);
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          window.history.replaceState(window.history.state, '', u.toString());
        } catch (e) {}
      }
    }
    if (!offersRoot && sets.length) {
      sets.forEach(function (fs) { fs.addEventListener('change', function () { update(true); }); });
      update(false);
    }

    if (!form) return;
    // contenu à ajouter : soit le pack choisi (une ligne par taille + cadeaux), soit le formulaire simple
    function offerItems() {
      var card = offersRoot.querySelector('[data-tk-offer].is-selected') || offerCards[0];
      if (!card) return null;
      var counts = {}, order = [], bad = false;
      var rows = qsa('[data-tk-unit]', card);
      rows.forEach(function (row) {
        var o = qsa('[data-tk-unit-select]', row).map(function (s) { return s.value; });
        var v = find(o);
        if (!v || !v.available) { bad = true; return; }
        if (!counts[v.id]) { counts[v.id] = 0; order.push(v.id); }
        counts[v.id]++;
      });
      if (bad) return false;
      if (!rows.length && idInput) { order.push(idInput.value); counts[idInput.value] = +card.getAttribute('data-units') || 1; }
      var items = order.map(function (id) { return { id: +id, quantity: counts[id] }; });
      qsa('[data-tk-gift]', card).forEach(function (g) {
        items.push({ id: +g.getAttribute('data-tk-gift'), quantity: 1, properties: { _gratis: '1' } });
      });
      return items;
    }

    form.addEventListener('submit', function (e) {
      var mode = sec.getAttribute('data-after-add');
      if (!offersRoot && mode !== 'drawer') return; // envoi classique (page panier ou paiement)
      e.preventDefault();
      if (btn.disabled) return;
      if (errEl) errEl.hidden = true;
      var request;
      if (offersRoot) {
        var items = offerItems();
        if (!items) { validateOffer(); showError(sec.getAttribute('data-soldout')); return; }
        request = { headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) };
      } else {
        request = { headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form) };
      }
      btn.setAttribute('aria-busy', 'true');
      btn.disabled = true;
      fetch(sec.getAttribute('data-cart-add-url') + '.js', { method: 'POST', headers: request.headers, body: request.body })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error((res.body && (res.body.description || res.body.message)) || '');
          document.dispatchEvent(new CustomEvent('tk:cart-updated'));
          if (mode === 'checkout') { window.location.href = '/checkout'; return; }
          if (mode === 'drawer' && T.cart) return T.cart.refresh().then(T.cart.open);
          window.location.href = sec.getAttribute('data-cart-url');
        })
        .catch(function (err) { showError(err && err.message); })
        .then(function () {
          btn.removeAttribute('aria-busy');
          if (offersRoot) validateOffer(true);
          else if (sets.length) update(false, true);
          else btn.disabled = false;
        });
    });
  }

  /* -------------------------------------------------------------- guide des tailles (dialog) */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-tk-dialog-open]');
    if (opener) {
      var d = document.getElementById(opener.getAttribute('data-tk-dialog-open'));
      if (!d) return;
      if (typeof d.showModal === 'function') { if (!d.open) { d.showModal(); lock(); } }
      else d.setAttribute('open', '');
      return;
    }
    var closer = e.target.closest('[data-tk-dialog-close]');
    if (closer) {
      var dlg = closer.closest('dialog');
      if (dlg) { if (typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open'); }
      return;
    }
    // clic sur le fond (hors contenu) : fermeture
    if (e.target.tagName === 'DIALOG' && e.target.classList.contains('tk-dialog') && typeof e.target.close === 'function') {
      e.target.close();
    }
  });
  document.addEventListener('close', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('tk-dialog')) unlock();
  }, true);

  /* -------------------------------------------------------------- défilement vers le bloc d'achat */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-tk-scroll-buy]');
    if (!a) return;
    var target = document.getElementById('tk-buy');
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  /* -------------------------------------------------------------- tiroir panier */
  function initDrawer() {
    var el = document.getElementById('TournikaCart');
    if (!el || el.getAttribute('data-tk-ready')) return;
    el.setAttribute('data-tk-ready', '1');
    var S = {};
    try { S = JSON.parse(el.querySelector('[data-tk-cart-strings]').textContent); } catch (e) {}
    var list = el.querySelector('[data-tk-cart-items]');
    var empty = el.querySelector('[data-tk-cart-empty]');
    var foot = el.querySelector('[data-tk-cart-footer]');
    var subtotal = el.querySelector('[data-tk-cart-subtotal]');
    var panel = el.querySelector('.tk-drawer__panel');
    var lastFocus = null, busy = false, isOpen = false;

    function money(cents, currency) {
      try {
        return new Intl.NumberFormat(S.locale || 'pl-PL', { style: 'currency', currency: currency || 'PLN' }).format(cents / 100);
      } catch (e) { return (cents / 100).toFixed(2) + ' ' + (currency || ''); }
    }
    function img(url) {
      if (!url) return '';
      return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=160';
    }
    function line(it, cur) {
      var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<span class="tk-line__variant">' + esc(it.variant_title) + '</span>' : '';
      var price = '';
      if (it.original_line_price > it.final_line_price) price += '<s>' + money(it.original_line_price, cur) + '</s>';
      price += money(it.final_line_price, cur);
      return '<div class="tk-line" data-key="' + esc(it.key) + '" data-q="' + it.quantity + '">' +
        (it.image ? '<img class="tk-line__img" src="' + esc(img(it.image)) + '" alt="" width="76" height="76" loading="lazy">' : '<span class="tk-line__img"></span>') +
        '<div>' +
          '<a class="tk-line__title" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + variant +
          '<div class="tk-line__row">' +
            '<div class="tk-qty"><button type="button" data-step="-1" aria-label="' + esc(S.minus || '-') + '">−</button><span>' + it.quantity + '</span><button type="button" data-step="1" aria-label="' + esc(S.plus || '+') + '">+</button></div>' +
            '<span class="tk-line__price">' + price + '</span>' +
          '</div>' +
          '<button type="button" class="tk-line__remove" data-remove>' + esc(S.remove || '×') + '</button>' +
        '</div>' +
      '</div>';
    }
    function render(cart) {
      var has = cart.item_count > 0;
      list.innerHTML = cart.items.map(function (it) { return line(it, cart.currency); }).join('');
      empty.hidden = has;
      foot.hidden = !has;
      subtotal.textContent = money(cart.total_price, cart.currency);
      qsa('[data-tk-cart-count]').forEach(function (n) { n.textContent = cart.item_count; n.hidden = !has; });
      return cart;
    }
    function refresh() {
      return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(render);
    }
    function change(key, q) {
      if (busy) return;
      busy = true;
      el.classList.add('is-busy');
      fetch(root() + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: q })
      })
        .then(function (r) { return r.json(); })
        .then(render)
        .catch(function () {})
        .then(function () { busy = false; el.classList.remove('is-busy'); });
    }
    function open() {
      if (isOpen) return;
      isOpen = true;
      lastFocus = document.activeElement;
      el.hidden = false;
      lock();
      requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add('is-open'); }); });
      if (panel) panel.focus();
    }
    function close() {
      if (!isOpen) return;
      isOpen = false;
      el.classList.remove('is-open');
      unlock();
      setTimeout(function () { if (!isOpen) el.hidden = true; }, 300);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    list.addEventListener('click', function (e) {
      var row = e.target.closest('.tk-line');
      if (!row) return;
      var key = row.getAttribute('data-key'), q = +row.getAttribute('data-q');
      var step = e.target.closest('[data-step]');
      if (step) { change(key, Math.max(0, q + (+step.getAttribute('data-step')))); return; }
      if (e.target.closest('[data-remove]')) change(key, 0);
    });
    el.addEventListener('click', function (e) { if (e.target.closest('[data-tk-cart-close]')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen) close(); });
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-tk-cart-open]')) { e.preventDefault(); refresh().then(open, open); }
    });

    T.cart = { open: open, close: close, refresh: refresh };
    refresh().catch(function () {});
  }

  /* -------------------------------------------------------------- compte à rebours (vraie date de fin uniquement) */
  function initCountdown(el) {
    if (el.getAttribute('data-tk-ready')) return;
    el.setAttribute('data-tk-ready', '1');
    var end = new Date((el.getAttribute('data-tk-countdown') || '').trim().replace(' ', 'T'));
    var out = el.querySelector('[data-tk-countdown-value]');
    if (isNaN(end.getTime()) || !out) return;
    function two(n) { return (n < 10 ? '0' : '') + n; }
    var timer = null;
    function tick() {
      var s = Math.floor((end.getTime() - Date.now()) / 1000);
      if (s <= 0) { el.hidden = true; if (timer) clearInterval(timer); return; }
      var d = Math.floor(s / 86400); s -= d * 86400;
      var h = Math.floor(s / 3600); s -= h * 3600;
      var m = Math.floor(s / 60); s -= m * 60;
      out.textContent = (d > 0 ? d + ' d ' : '') + two(h) + ':' + two(m) + ':' + two(s);
      el.hidden = false;
    }
    tick();
    if (!el.hidden) timer = setInterval(tick, 1000);
  }

  /* -------------------------------------------------------------- démarrage + éditeur de thème */
  function init(scope) {
    qsa('[data-tk-countdown]', scope).forEach(initCountdown);
    qsa('[data-tk-gallery]', scope).forEach(initGallery);
    qsa('[data-tk-carousel]', scope).forEach(initCarousel);
    qsa('[data-tk-product]', scope).forEach(initProduct);
    initDrawer();
  }
  T.init = init;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest ? e.target.closest('[data-tk-slide]') : null;
    if (!slide) return;
    var car = slide.closest('[data-tk-carousel]');
    if (car && car.tkSlides && car.tkGoTo) car.tkGoTo(car.tkSlides.indexOf(slide));
  });
})();